export const maxWidthForActionsSection = 700;
